const ThickSimpleArrowIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="3"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );
};

export default ThickSimpleArrowIcon;
